// in order for vite to properly export these variables,
// this file extension MUST be .module.scss
// https://vitejs.dev/guide/features.html#css-modules

// Vite prepends premialab/defaults before this file, so the whitelabel styling has to be imported first.
// The defaults import below then runs again and rebuilds the maps from the whitelabel styling colors.
@import '@/build/active/bootstrap.scss';
@import './premialab/defaults';
@import './premialab/extra-colors';

:export {
  $all-colors: map-merge(
    $map1: $theme-colors,
    $map2: $used-colors,
  );
  $all-colors: map-merge(
    $map1: $all-colors,
    $map2: $grays,
  );

  @each $name, $color in $all-colors {
    #{$name}: $color;
  }

  font: $platform-font;
  monospaceFont: $platform-monospace-font;
  cornerRadius: $border-radius;
}
